import React from "react"
// import { Link } from "gatsby"
import styled from "@emotion/styled"
import tw from "twin.macro"

import { withAccountWidget } from "./withAccountWidget"
import { AccountDrawer } from "../Drawer/AccountDrawer"

import { Icon } from "../../Icon/Icon"
import { StyledButton } from "../../Styled/Button"

export const Desktop = tw.div`hidden md:block`
export const Mobile = tw.div`block md:hidden`
export const DesktopButton = styled(StyledButton)`
  ${tw`hidden md:block ml-0-6 md:ml-1 transition-all duration-slow z-50 md:px-0-5`}
  ${({ display }) => (display ? tw`opacity-100 visible` : tw`opacity-0 invisible`)}
`
// added padding new changes
export const MobileButton = styled(StyledButton)`
  ${tw`block md:hidden ml-0-6 md:ml-1 transition-all duration-slow z-50 px-0-5`}
  ${({ display }) => (display ? tw`opacity-100 visible` : tw`opacity-0 invisible`)}
`

export const StyledIcon = styled(Icon)`
  ${tw`m-auto`}
`

export const AccountWidget = withAccountWidget(
  ({ handleClick, handleClickMobileWidget, activeCart, activeMenu, activeAccount, isAccountPage }): JSX.Element => {
    return (
      <>
        <DesktopButton
          className={`icon-button`}
          display={!activeCart ? "true" : undefined}
          layout={`icon`}
          onClick={handleClick}
          background={isAccountPage ? `dark` : `light`}
          active={isAccountPage}
        >
          {/* <StyledIcon name={`account`} size={15} /> */}
          <StyledIcon name={`account`} size={24} />
        </DesktopButton>
        <MobileButton
          className={`icon-button`}
          // display={!activeCart && activeMenu ? "true" : undefined}
          display={!activeCart && !activeMenu ? "true" : undefined}
          layout={`icon`}
          onClick={handleClickMobileWidget}
          background={activeAccount ? `dark` : `light`}
          active={activeAccount}
        >
          <StyledIcon name={`account`} size={24} />
        </MobileButton>
        <Mobile>
          <AccountDrawer />
        </Mobile>
      </>
    )
  }
)
